import { configureStore } from '@reduxjs/toolkit';
import filtersReducer from './reducers/filtersReducer';
import pendingCountsReducer from './slices/pending-counts';
import drawerReducer from './slices/drawerSlice';
import refreshReducer from './slices/refreshSlice';
import offerLetterReducer from './slices/offerLetterSlice';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import permissionReducer from './slices/permissionSlice';
import planReducer from './slices/planSlice';
import tenantValidationReducer from './slices/tenantValidationSlice';
import setupChecklistReducer from './slices/setupChecklistSlice';

import tenantPreferenceReducer from './slices/tenantPreferenceSlice';
import masterDataReducer from './slices/masterDataSlice';

const store = configureStore({
  reducer: {
    filters: filtersReducer,
    pendingCounts: pendingCountsReducer,
    drawer: drawerReducer,
    refresh: refreshReducer,
    offerLetter: offerLetterReducer,
    auth: authReducer,
    user: userReducer,
    permission: permissionReducer,
    plan: planReducer,
    tenantValidation: tenantValidationReducer,
    setupChecklist: setupChecklistReducer,
    tenantPreference: tenantPreferenceReducer,
    masterData: masterDataReducer,
  },
});

export default store;
